import { render, staticRenderFns } from "./social_milestone.vue?vue&type=template&id=a1d3c42e&"
import script from "./social_milestone.vue?vue&type=script&lang=js&"
export * from "./social_milestone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports